import { Routes, RouterModule } from '@angular/router';
import { MetaGuard } from '@ngx-meta/core';

import { PosGraduacaoComponent } from './pos-graduacao.component';

import { INSCRICAO_ROUTER } from './inscricao/inscricao.router';
import { ESPECIALIZACAO_ROUTER } from './especializacao/especializacao.router';
import { MESTRADO_ROUTER } from './mestrado/mestrado.router';
import { DOUTORADO_ROUTER } from './doutorado/doutorado.router';
import { ACOMPANHAMENTO_ROUTER } from './acompanhamento/acompanhamento.router';
import { POS_ROUTER } from './pos-graduacao/pos.router'
import { POSMED_ROUTER } from './pos-med/pos-med.router';

const POS_GRADUACAO_ROUTER: Routes = [
  {
    path: '',
    component: PosGraduacaoComponent,
    canActivateChild: [MetaGuard],
    children: [
      { path: '', pathMatch: 'full' },
      ...ACOMPANHAMENTO_ROUTER,
      ...INSCRICAO_ROUTER,
      ...ESPECIALIZACAO_ROUTER,
      ...MESTRADO_ROUTER,
      ...DOUTORADO_ROUTER,
      ...POSMED_ROUTER,
      ...POS_ROUTER
    ],
    data: {
      meta: {
        title: 'Pós Graduação',
        description: 'Conheça os cursos da melhor Universidade do Maranhão',
      },
    },
  },
];

export const PosGraduacaoRouter = RouterModule.forChild(POS_GRADUACAO_ROUTER);
